/* eslint-disable */
import React, { useCallback, useRef } from 'react';
import CheckBox from 'ui-kit/old/checkbox';
import * as Styled from '../styles';
import { ButtonTab } from 'ui-kit/Tab/tab.style';

function ControlItem({
  label,
  isChecked,
  handleOptionChange,
  optionValue,
  disabled,
  columnRef,
  index,
  setFocusedColumn,
  focusedColumn,
  iEdisabled,
}) {
  const ref = useRef(null);

  const handleChange = useCallback(() => {
    handleOptionChange(optionValue);
    setFocusedColumn(index);
  }, [handleOptionChange, index, optionValue, setFocusedColumn]);

  const handleKeyDown = (e) => {
    if (e.keyCode === 9) {
      e.preventDefault();
    }
  };

  return (
    <Styled.ListItem onKeyDown={handleKeyDown}>
      <CheckBox
        key={label}
        name={label}
        labelText={label}
        isEnforcement
        isChecked={isChecked}
        onChange={handleChange}
        disabled={disabled}
        innerRef={columnRef}
        tabIndex={focusedColumn === index ? 0 : -1}
        iEdisabled={iEdisabled}
      />
    </Styled.ListItem>
  );
}

export default ControlItem;
